import React, { useState } from "react";

export default function NotificationHeader({sortFun,displayIcon,name}){
    const [isClick,setIsClicked] = useState(false);

    const clicked = () =>{
        setIsClicked(!isClick);
        sortFun(!isClick?'ASC':'DESC')
    }
    return <th className="text-dark" style={{ width: 70 + "%",cursor: 'pointer' }}>
    <a className="resetAction asc" onClick={()=>clicked()}>
      {name} {displayIcon && <i className="fa fa-sort" onClick={(e)=>{e.stopPropagation();clicked()}}></i>}
      </a>
  </th>
}